var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z4 close-button pointer",class:{ left: _vm.left },on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":require("@/assets/icon-close-red.svg"),"alt":"Button: Close"}})])}
var staticRenderFns = []

export { render, staticRenderFns }